/* eslint-disable no-param-reassign */
export const downloadCSV = ({ csv, refToCSVLink }) => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  refToCSVLink.current.href = URL.createObjectURL(blob);
  refToCSVLink.current.click();
};
